module.exports = __webpack_public_path__ + "assets/img/00003.3e40149c.png";